export default [
  // 三方渠道借款中间页（榕树渠道易借H5）
  {
    path: '/channel/borrow/loading',
    name: 'channel_borrow_loading',
    meta: {
      title: '加载中'
    },
    component: () =>
      import('@/pages/channel-h5/borrow/loading.vue')
  },
  // 三方渠道CA中间页（榕树渠道易借H5）
  {
    path: '/channel/borrow/ca-verify',
    name: 'channel_borrow_caverify',
    meta: {
      title: '加载中'
    },
    component: () =>
      import('@/pages/channel-h5/borrow/ca-verify.vue')
  },
  // 三方渠道还款中间页（榕树渠道易借H5）
  {
    path: '/channel/repayment/loading',
    name: 'channel_repayment_loading',
    meta: {
      title: '加载中'
    },
    component: () =>
      import('@/pages/channel-h5/repayment/loading.vue')
  },
  // 渠道 H5 统一借款入口：根据实时借款状态进入申请、会员、审核或结果页
  {
    path: '/channel/borrow-entry',
    name: 'channel_h5_borrow_entry',
    meta: {
      title: '借款'
    },
    component: () => import('@/pages/channel-h5/borrow-entry.vue')
  },
  // 渠道 H5 统一还款入口：进入现有待还账单流程
  {
    path: '/channel/repay-entry',
    name: 'channel_h5_repay_entry',
    meta: {
      title: '还款'
    },
    component: () => import('@/pages/channel-h5/repay-entry.vue')
  },
  // 首页
  {
    path: '/index',
    name: 'home_index',
    meta: {
      title: '易借',
      keepAlive: true
    },
    component: resolve => (require(['@/pages/home/index/index'], resolve))
  },
  // 京东金融首页
  {
    path: '/home/jd',
    name: 'home_jd',
    meta: {
      title: '易借'
    },
    component: resolve => (require(['@/pages/home/jingdong/index'], resolve))
  },
  // 首页常见问题
  {
    path: '/commonissue',
    name: 'commonissue',
    meta: {
      title: '常见问题'
    },
    component: () =>
      import('@/pages/home/commonissue')
  },
  // 借还记录
  {
    path: '/repayment/record',
    name: 'repayment_record',
    meta: {
      title: '借还记录',
      keepAlive: true
    },
    component: () =>
      import('@/pages/repayment/borrow-repay-record.vue')
  },
  // 还款详情
  {
    path: '/repayment/detailrepay',
    name: 'repayment_detailrepay',
    meta: {
      title: '还款详情'
    },
    component: () =>
      import('@/pages/repayment/detail-repay/index')
  },
  // 还款流水明细
  {
    path: '/repayment/inventory',
    name: 'repayment_inventory',
    meta: {
      title: '应还借款清单'
    },
    component: () =>
      import('@/pages/repayment/repaymentinventory')
  },
  // 锡商&杭金投应还借款清单
  {
    path: '/repayment/payablelist',
    name: 'repayment_payablelist',
    meta: {
      title: '应还借款清单'
    },
    component: () =>
      import('@/pages/repayment/repay-payablelist')
  },
  // 提前贷款还款
  {
    path: '/repayment/loan',
    name: 'repayment_loan',
    meta: {
      title: '应还借款清单'
    },
    component: () =>
      import('@/pages/repayment/repaymentloan')
  },
  // 贷款详情
  {
    path: '/repayment/loanConsuDetails',
    name: 'repayment_loanConsuDetails',
    meta: {
      title: '查看详情'
    },
    component: () =>
      import('@/pages/repayment/loanConsuDetails')
  },
  // 贷款详情
  {
    path: '/repayment/details',
    name: 'repayment_details',
    meta: {
      title: '贷款详情'
    },
    component: () =>
      import('@/pages/repayment/loansdetails')
  },
  // 结清证明
  {
    path: '/repayment/clearanceCertificate',
    name: 'repayment_clearanceCertificate',
    meta: {
      title: '结清证明'
    },
    component: () =>
      import('@/pages/repayment/clearanceCertificate')
  },
  // 支付
  {
    path: '/repayment/payment',
    name: 'repayment_payment',
    meta: {
      title: '支付'
    },
    component: () =>
      import('@/pages/repayment/payment')
  },
  // 还款计划
  {
    path: '/repayment/plan',
    name: 'repayment_plan',
    meta: {
      title: '还款计划'
    },
    component: () =>
      import('@/pages/repayment/repaymentplan/index')
  },
  // 贷后服务费
  {
    path: '/repayment/consuPlan',
    name: 'repayment_consuPlan',
    meta: {
      title: '贷后服务费'
    },
    component: () =>
      import('@/pages/repayment/repaymentplan/consuPlan')
  },
  // 单笔借据债务未还账单
  {
    path: '/repayment/billrecord/consubill',
    name: 'repayment_billrecord_consubill',
    meta: {
      title: '待支付账单'
    },
    component: () =>
      import('@/pages/repayment/billrecord/consuBill')
  },
  // 单笔借据未还账单
  {
    path: '/repayment/billrecord',
    name: 'repayment_billrecord',
    meta: {
      title: '未还账单'
    },
    component: () =>
      import('@/pages/repayment/billrecord/index')
  },
  // 存在多笔借款订单未结清时
  {
    path: '/repayment/billRecordMultiple',
    name: 'repayment_billRecordMultiple',
    meta: {
      title: '未还账单'
    },
    component: () =>
      import('@/pages/repayment/billrecord/billRecordMultiple')
  },
  {
    path: '/repayment/nobill',
    name: 'repayment_nobill',
    meta: {
      title: '未还账单'
    },
    component: () =>
      import('@/pages/repayment/billrecord/no-data')
  },
  // 本利担贷款详情
  {
    path: '/repayment/billDetail',
    name: 'repayment_billDetail',
    meta: {
      title: '账单详情'
    },
    component: () =>
      import('@/pages/repayment/billDetail')
  },
  // 还款申请结果页
  {
    path: '/repayment/result',
    name: 'repayment_result',
    meta: {
      title: '还款结果'
    },
    component: () =>
      import('@/pages/repayment/result/index')
  },
  // 还款银行卡添加
  {
    path: '/repayment/bindbankcard',
    name: 'repayment_bindbankcard',
    meta: {
      title: '绑定银行卡',
      keepAlive: true
    },
    component: () =>
      import('@/pages/repayment/bindbankcard')
  },
  // 居住地址
  // {
  //   path: '/auth/residentialAddress',
  //   name: 'auth/residentialAddress',
  //   meta: {
  //     title: '居住地址'
  //   },
  //   component: () => import('@/pages/auth/residentialAddress')
  // },
  {
    path: '/auth/result',
    name: 'auth_result',
    meta: {
      title: '安全认证'
    },
    component: () =>
      import('@/pages/auth/result')
  },
  {
    path: '/auth/validateuser',
    name: 'auth_validateuser',
    meta: {
      title: '验证方式'
    },
    component: () =>
      import('@/pages/auth/validateuser')
  },
  {
    path: '/auth/validatemsg',
    name: 'auth_validatemsg',
    meta: {
      title: '短信验证'
    },
    component: () =>
      import('@/pages/auth/validatemsg')
  },
  {
    path: '/auth/realname',
    name: 'auth_realname',
    meta: {
      title: '实名认证'
    },
    component: () =>
      import('@/pages/auth/realname')
  },
  // 身份认证
  {
    path: '/auth/identitycard',
    name: 'auth_identitycard',
    meta: {
      title: '身份认证',
      keepAlive: true
    },
    component: () =>
      import('@/pages/auth/identitycard/index')
  },
  {
    path: '/auth/idCardDetail',
    name: 'auth_idCardDetail',
    meta: {
      title: '实名认证'
    },
    component: () =>
      import('@/pages/auth/idCardDetail')
  },
  // 认证加载中
  {
    path: '/auth/loading',
    name: 'auth_loading',
    meta: {
      title: '额度申请'
    },
    component: () =>
      import('@/pages/auth/onePush')
  },
  // 认证加载中
  {
    path: '/auth/getAmount',
    name: 'auth_getAmount',
    meta: {
      title: '申请结果'
    },
    component: () =>
      import('@/pages/auth/getAmount')
  },
  // 认证失败
  {
    path: '/auth/getAmountFail',
    name: 'auth_getAmountFail',
    meta: {
      title: '申请结果'
    },
    component: () =>
      import('@/pages/auth/getAmountFail/index')
  },
  // API渠道不可见
  {
    path: '/auth/noborrow',
    name: 'auth_noborrow',
    meta: {
      title: '申请结果'
    },
    component: () =>
      import('@/pages/auth/getAmountFail/noborrow')
  },
  // 申请结果
  {
    path: '/auth/requireResult',
    name: 'auth_requireResult',
    meta: {
      title: '申请结果'
    },
    component: () =>
      import('@/pages/home/yjsd/requireResult')
  },
  // 申请结果
  {
    path: '/auth/auditResult',
    name: 'auth_auditResult',
    meta: {
      title: '申请结果'
    },
    component: () =>
      import('@/pages/auth/auditResult')
  },
  // 认证状态查询中间
  {
    path: '/auth/authloading',
    name: 'auth_authloading',
    meta: {
      title: '加载中'
    },
    component: () =>
      import('@/pages/auth/authloading')
  },
  // CA 人脸认证回跳结果页
  {
    path: '/auth/ca-verify-result',
    name: 'auth_ca_verify_result',
    meta: {
      title: '认证结果确认'
    },
    component: () =>
      import('@/pages/auth/ca-verify-result')
  },
  // 征信授信认证（协议合并）
  {
    path: '/auth/credit',
    name: 'auth_credit',
    meta: {
      title: '征信授信',
      keepAlive: true
    },
    component: () =>
      import('@/pages/auth/credit')
  },
  // 认证失败结果页
  {
    path: '/auth/authfail',
    name: 'auth_authfail',
    meta: {
      title: '授信审核'
    },
    component: () =>
      import('@/pages/auth/authfail')
  },
  // 借款人信息
  {
    path: '/auth/persioninfo',
    name: 'auth_persioninfo',
    meta: {
      title: '借款人信息'
    },
    component: () =>
      import('@/pages/auth/borrow-person-info/index')
  },
  // 人脸识别
  {
    path: '/auth/video',
    name: 'auth_video',
    meta: {
      title: '人脸识别',
      keepAlive: true,
      identityVerificationMode: 'login'
    },
    component: () =>
      import('@/pages/auth/video/index')
  },
  // 免登录核身不使用 keep-alive，避免一次性会话跨任务复用页面实例。
  {
    path: '/identity-verification/:verificationCode?',
    name: 'identity_verification',
    meta: {
      title: '人脸识别',
      identityVerificationMode: 'anonymous'
    },
    component: () =>
      import('@/pages/auth/video/index')
  },
  // 银行卡类型
  {
    path: '/auth/bankcardtype',
    name: 'auth_bankcardtype',
    meta: {
      title: '支持银行'
    },
    component: () =>
      import('@/pages/auth/bankcardtype')
  },
  // 绑定银行卡
  {
    path: '/auth/bindbankcard',
    name: 'auth_bindbankcard',
    meta: {
      title: '',
      keepAlive: true
    },
    component: () =>
      import('@/pages/auth/bindbankcard')
  },
  // 银行卡列表
  {
    path: '/auth/bankcardlist',
    name: 'auth_bankcardlist',
    meta: {
      title: '银行卡',
      keepAlive: true
    },
    component: () =>
      import('@/pages/auth/bankcard-list')
  },
  // 解绑银行卡
  {
    path: '/auth/bankcardunbind',
    name: 'auth_bankcardunbind',
    meta: {
      title: '银行卡管理',
      keepAlive: true
    },
    component: () =>
      import('@/pages/auth/bankcard-unbind')
  },
  // 行驶证、个税认证
  {
    path: '/auth/license',
    name: 'auth_license',
    meta: {
      title: '个税认证'
    },
    component: () =>
      import('@/pages/auth/license/index')
  },
  // 提额中心
  {
    path: '/auth/increaseAmountCenter',
    name: 'auth_increaseAmountCenter',
    meta: {
      title: '提额中心'
    },
    component: () =>
      import('@/pages/auth/increase-amount-center/index.vue')
  },
  // 车抵贷申请
  {
    path: '/auth/car-loan/apply',
    name: 'auth_car_loan_apply',
    meta: {
      title: '车抵贷申请'
    },
    component: () =>
      import('@/pages/auth/car-loan/apply.vue')
  },
  // 车抵贷申请结果
  {
    path: '/auth/car-loan/result',
    name: 'auth_car_loan_result',
    meta: {
      title: '申请结果'
    },
    component: () =>
      import('@/pages/auth/car-loan/result.vue')
  },
  // 联登-天创信用
  {
    path: '/auth/increaseCenter/joinLogin',
    name: 'auth_tcxy_join_login',
    meta: {
      title: '加载中'
    },
    component: () =>
      import('@/pages/auth/increase-amount-center/join-login.vue')
  },
  // 获取报告-天创信用
  {
    path: '/auth/increaseCenter/riskReport',
    name: 'auth_increaseRiskReport',
    meta: {
      title: '获取报告'
    },
    component: () =>
      import('@/pages/auth/increase-amount-center/risk-report/index.vue')
  },
  // 获取结果-天创信用
  {
    path: '/auth/increaseCenter/riskReportResult',
    name: 'auth_increaseRiskReportResult',
    meta: {
      title: '获取结果'
    },
    component: () =>
      import('@/pages/auth/increase-amount-center/risk-report/result.vue')
  },
  // 额度更新协议
  // {
  //   path: '/auth/creditupdate',
  //   name: 'auth_creditupdate',
  //   meta: {
  //     title: '额度更新'
  //   },
  //   component: () =>
  //     import('@/pages/auth/credit-update')
  // },
  // 额度更新中
  {
    path: '/auth/creditupdate',
    name: 'auth_creditupdate',
    meta: {
      title: '额度更新'
    },
    component: () =>
      import('@/pages/auth/credit-update/loading')
  },

  /**
   * 借款模块
   */
  // 申请借款
  {
    path: '/borrow/money',
    name: 'borrow_money',
    meta: {
      title: '申请借款',
      keepAlive: true
    },
    component: () =>
      import('@/pages/borrow/index')
  },
  {
    path: '/borrow/maintain',
    name: 'borrow_maintain',
    meta: {
      title: '维护中'
    },
    component: () =>
      import('@/pages/borrow/borrow-maintain')
  },
  // 申请借款-立即提现（放款失败）
  {
    path: '/borrow/withdraw',
    name: 'borrow_withdraw',
    meta: {
      title: '申请结果'
    },
    component: () =>
      import('@/pages/borrow/withdraw-money')
  },
  // 申请借款-额度提现
  {
    path: '/borrow/member',
    name: 'borrow_member',
    meta: {
      title: '额度提现'
    },
    component: () =>
      import('@/pages/borrow/member/index')
  },
  // 额度审核
  {
    path: '/borrow/audit',
    name: 'borrow_audit',
    meta: {
      title: '额度审核'
    },
    component: () =>
      import('@/pages/borrow/audit')
  },
  // 协议列表
  {
    path: '/borrow/protocolList',
    name: 'borrow_protocolList',
    meta: {
      title: '相关协议',
      keepAlive: true
    },
    component: () =>
      import('@/pages/protocol/borrow/index')
  },
  // 站内跳转使用(旧版协议模版)
  {
    path: '/borrow/protocolTemplate',
    name: 'borrow_protocol_template',
    meta: {
      title: ''
    },
    component: () =>
      import('@/pages/protocol/borrow/template')
  },
  // 站内跳转使用(新版协议模版)
  {
    path: '/borrow/newtemplate',
    name: 'borrow_protocol_newtemplate',
    meta: {
      title: ''
    },
    component: () =>
      import('@/pages/protocol/borrow/newtemplate')
  },
  // 选择银行卡
  {
    path: '/borrow/choosebank',
    name: 'borrow_choosebank',
    meta: {
      title: '选择银行卡'
    },
    component: () =>
      import('@/pages/borrow/choosebank')
  },
  // 绑定银行卡
  {
    path: '/borrow/bindbankcard',
    name: 'borrow_bindbankcard',
    meta: {
      keepAlive: true,
      title: '绑定银行卡'
    },
    component: () =>
      import('@/pages/borrow/bindbankcard')
  },
  // 借款确认
  {
    path: '/borrow/confirm',
    name: 'borrow_confirm',
    meta: {
      title: '借款确认'
    },
    component: () =>
      import('@/pages/borrow/borrowconfirm')
  },
  // 借款确认
  {
    path: '/borrow/billDetail',
    name: 'borrow_bill_detail',
    meta: {
      title: '账单详情'
    },
    component: () =>
      import('@/pages/borrow/borrow-bill-detail')
  },
  // 借款结果人脸loading页（中原api）
  {
    path: '/borrow/video-loading',
    name: 'borrow_video_loading',
    meta: {
      title: '借款申请'
    },
    component: () =>
      import('@/pages/borrow/borrow-video-loading.vue')
  },
  // 借款结果页
  {
    path: '/borrow/result/loading',
    name: 'borrow_result_loading',
    meta: {
      title: '提交中',
      keepAlive: true
    },
    component: () =>
      import('@/pages/borrow/result/loading')
  },
  // 60s借款结果loading页
  {
    path: '/borrow/result/loading-failed',
    name: 'borrow_result_loading_failed',
    meta: {
      title: '提交中',
      keepAlive: true
    },
    component: () =>
      import('@/pages/borrow/result/loading-failed')
  },
  {
    path: '/borrow/result',
    name: 'borrow_result',
    meta: {
      title: '提交成功'
    },
    component: () =>
      import('@/pages/borrow/result/index')
  },
  {
    path: '/borrow/result/wait',
    name: 'borrow_result_wait',
    meta: {
      title: '审核中'
    },
    component: () =>
      import('@/pages/borrow/result/wait.vue')
  },
  // 时光分期渠道 - 被拒结果页
  {
    path: '/borrow/result/third',
    name: 'borrow_result_third',
    meta: {
      title: '易借速贷'
    },
    component: () =>
      import('@/pages/borrow/result/third-sgfq')
  },
  // 借款失败
  {
    path: '/borrow/fail',
    name: 'borrow_fail',
    meta: {
      title: '借款失败'
    },
    component: () =>
      import('@/pages/borrow/borrowfail')
  },
  // 服务授权
  {
    path: '/borrow/serviceAgree',
    name: 'borrow/serviceAgree',
    meta: {
      title: '服务授权'
    },
    component: () =>
      import('@/pages/borrow/service-agree')
  },
  // 预约借款
  {
    path: '/borrow/orderborrow',
    name: 'borrow/orderborrow',
    meta: {
      title: '预约借款'
    },
    component: () =>
      import('@/pages/borrow/orderborrow')
  },
  {
    path: '/borrow/loading',
    name: 'borrow_loading',
    meta: {
      title: '放款审核中'
    },
    component: () =>
      import('@/pages/borrow/borrowloading')
  },
  {
    path: '/app/issue',
    name: 'home_appissue',
    meta: {
      title: '客服与投诉'
    },
    component: () =>
      import('@/pages/home/app-issue')
  },
  {
    path: '/app/myService',
    name: 'home_myService',
    meta: {
      title: '我的服务'
    },
    component: () =>
      import('@/pages/home/myService/index')
  },
  {
    path: '/app/myService/detail',
    name: 'home_myService_detail',
    meta: {
      title: '我的服务'
    },
    component: () =>
      import('@/pages/home/myService/detail')
  },
  {
    path: '/app/supervision',
    name: 'app_supervision',
    meta: {
      title: '监管举报专线'
    },
    component: () =>
      import('@/pages/activity/app/setup/supervision')
  },
  // 回退刷新页面
  {
    path: '/rollback',
    name: 'rollback',
    meta: {
      title: ''
    },
    component: () =>
      import('@/components/rollback')
  },
  // 龙享花登录（龙商支付通道过审流程）
  {
    path: '/lxhLogin',
    name: 'home_lxhLogin',
    meta: {
      title: '龙享花'
    },
    component: () =>
      import('@/pages/home/lxhLogin.vue')
  },
  // 龙享花首页（龙商支付通道过审流程）
  {
    path: '/home/lxh',
    name: 'home_lxh',
    meta: {
      title: '龙享花',
      keepAlive: true
    },
    component: () =>
      import('@/pages/home/lxh/index.vue')
  },
  // H5登录（场景登录）
  {
    path: '/channelLogin',
    name: 'home_channelLogin',
    meta: {
      title: '易借'
    },
    component: () =>
      import('@/pages/home/channelLogin')
  },
  // H5半流程（首页）
  {
    path: '/home/yjsd',
    name: 'home_yjsd',
    meta: {
      title: '易借速贷'
    },
    component: () =>
      import('@/pages/home/yjsd/index')
  },
  // H5登录（还款专用）
  {
    path: '/login',
    name: 'home_login',
    meta: {
      title: '易借'
    },
    component: () =>
      import('@/pages/home/login')
  },
  // 锡锡贷-补充认证
  {
    path: '/xxdauth/verify',
    name: 'xxdauth_verify',
    meta: {
      title: '审核中'
    },
    component: () =>
      import('@/pages/auth/xxd-verify/index')
  },
  // 锡锡贷-借款前协议页
  {
    path: '/xxdborrow/index',
    name: 'xxdborrow_index',
    meta: {
      title: '借款申请'
    },
    component: () =>
      import('@/pages/borrow/xxd/index')
  },
  // 锡锡贷借款页先享后付绑卡
  {
    path: '/xxdborrow/firstenjoy/bindcard',
    name: 'xxdborrow_firstenjoy_bindcard',
    meta: {
      title: ''
    },
    component: () =>
      import('@/pages/borrow/xxd/first-enjoy/first-enjoy-bindcard')
  },
  // 锡锡贷借款页权益详情
  {
    path: '/xxdborrow/firstenjoy/benefitdetail',
    name: 'xxdborrow_firstenjoy_benefitdetail',
    meta: {
      title: ''
    },
    component: () =>
      import('@/pages/borrow/xxd/first-enjoy/first-enjoy-benefitdetail')
  },
  // 锡锡贷-借款结果页loaing
  {
    path: '/xxdborrow/loading',
    name: 'xxdborrow_loading',
    meta: {
      title: '提交中',
      keepAlive: true
    },
    component: () =>
      import('@/pages/borrow/xxd/xxd-borrowresult/loading')
  },
  // 锡锡贷-借款结果页
  {
    path: '/xxdborrow/result',
    name: 'xxdborrow_result',
    meta: {
      title: '提交成功'
    },
    component: () =>
      import('@/pages/borrow/xxd/xxd-borrowresult/index')
  },
  // 还款申请成功
  {
    path: '/xxdrepayment/result',
    name: 'xxdrepayment_result',
    meta: {
      title: '还款结果'
    },
    component: () =>
      import('@/pages/repayment/result/xxd-result')
  }
]
